"use client";

import React from "react";
import { ArrowUp, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section data-section-id="254422" id="footer" className="dark bg-foreground text-background relative overflow-hidden py-12 border-t border-border/20">
      {}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-32 bg-primary/10 blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {}
          <div className="hidden md:block flex-1" />

          {}
          <div className="flex flex-col items-center gap-6 flex-1">
            <Link to="/HomePage" className="transition-transform hover:scale-105 duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-md">
              <WvcLogo className="h-10 w-auto opacity-100 hover:opacity-90 transition-opacity" />
            </Link>
            
            <div className="flex flex-col items-center gap-1 text-center">
              <p className="font-default text-background/80 text-sm">
                © {new Date().getFullYear()} BuyMyMSP. All rights reserved.
              </p>
              <p className="font-default text-primary text-xs tracking-widest uppercase font-semibold">
                Premium MSP Brokerage Services
              </p>
            </div>
          </div>

          {}
          <div className="flex-1 flex justify-center md:justify-end">
            <Button variant="outline" size="icon" onClick={scrollToTop} className="h-12 w-12 rounded-md border-background/20 bg-foreground/50 backdrop-blur-sm text-background hover:bg-primary hover:text-primary-foreground hover:-translate-y-2 transition-all duration-500 shadow-lg shadow-black/40 group relative border-dotted" aria-label="Scroll back to top">
              <ArrowUp className="size-5 transition-transform duration-300 group-hover:animate-bounce" />
              <Sparkles className="size-4 absolute -top-2 -right-2 text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}